<template>
    <div>
        <div class="modal fade" id="modalLogin">
            <div class="modal-dialog">
                <div class="modal-content no-r">
                    <a href="#" data-dismiss="modal" aria-label="Close" class="paper-nav-toggle active"><i></i></a>
                    <div class="modal-body no-p">
                        <div class="text-center p-20 p-b-0">
                            <!-- <img class="w-30" :src="url + '/frontend/img/comfy/logo-light.png'" alt=""> -->
                            <p class="p-t-20 mb-0">Es hora de un masaje, ingresa tus datos para iniciar sesión.</p>
                        </div>
                        <div class="p-4">
                            <form class="form-horizontal login" method="post" @submit="postLogin" novalidate="true">
                                <div class="form-group">
                                    <i class="icon-envelope-o"></i>
                                    <label>Escribe tu correo (requerido)</label>
                                    <el-input placeholder="@" autocomplete="on" name="email" v-model="fillLoginUsuario.cEmail" @keyup.enter="postLogin" clearable @input="reglaCorreo"></el-input>
                                </div>
                                <div class="form-group">
                                    <i class="icon-key4"></i>
                                    <label>Escribe tu contraseña (requerido)</label>
                                    <el-input placeholder="Escribe tu contraseña" v-model="fillLoginUsuario.cPassword" show-password></el-input>
                                </div>
                                <div class="form-check registro-cliente">
                                    <el-checkbox v-model="aceptoPoliticas">Acepto los <a :href="url + '/terminos-y-condiciones'" target="_blank">Términos y Condiciones</a> del servicio y <a :href="url + '/proteccion-datos'" target="_blank">Políticas de Protección de Datos Personales</a>.</el-checkbox>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-12">
                                        <button type="submit" v-loading.fullscreen.lock="fullscreenLoading" class="btn btn-primary comfy btn-sm btn-block mb-3 cursor-pointer">Iniciar sesión</button>
                                    </div>
                                </div>
                                <div class="mb-3" v-if="error">
                                    <div class="text-danger" v-for="(item, items) in mensajeError" v-text="item"></div>
                                </div>
                            </form>

                            <div class="form-group d-flow-root">
                                <small class="forget-pass float-left"><a :href="url + '/password/reset'">Olvidé mi contraseña</a></small>
                                <small class="forget-pass float-right"><a data-toggle="modal" data-target="#modalSignUp" data-dismiss="modal" href="#">Crear nueva cuenta Comfy</a></small>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['url'],
        data() {
            return {
                fillLoginUsuario: {
                    'cEmail': '',
                    'cPassword': ''
                },
                aceptoPoliticas: false,
                error: 0,
                mensajeError: [],
                fullscreenLoading: false,
                type: '',
                cliente: []
            }
        },
        computed: {

        },
        methods: {
            reglaCorreo(val){
                this.fillLoginUsuario.cEmail = val.replace(/[&\/\\#, +()$~%'":*?<>{}\s]/g, '');
            },
            validarDatosUsuario(){
                this.error = 0
                this.mensajeError = []
                if(!this.fillLoginUsuario.cEmail){
                    this.mensajeError.push('El correo es un campo obligatorio.')
                }else if (!this.validEmail(this.fillLoginUsuario.cEmail)){
                    this.mensajeError.push('El correo electrónico debe ser válido.')
                }
                if(!this.fillLoginUsuario.cPassword){
                    this.mensajeError.push('La contraseña es un campo obligatorio.')
                }
                if(!this.aceptoPoliticas){
                    this.mensajeError.push('Debes aceptar nuestros términos y condiciones de servicio para poder ingresar.')
                }
                if(this.mensajeError.length){
                    this.fullscreenLoading = false
                    this.error = 1
                }
                return this.error
            },
            validEmail: function (email) {
                var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return regex.test(email);
            },
            postLogin(e){
                e.preventDefault();
                this.fullscreenLoading = true
                if(this.validarDatosUsuario()){
                    return
                }
                var url = '/authenticate/login'
                let params = this.fillLoginUsuario
                axios.post(url, params).then(response => {
                    this.type = response.data.type
                    $('#modalLogin').modal('hide')
                    if(response.data.type == 'administrador'){
                        location.replace('/administrador')
                    }else if(response.data.type == 'terapista'){
                        location.replace('/')
                    }else if(response.data.type == 'agency'){
                        location.replace('/agency')
                    }else if(response.data.type == 'cliente'){
                        this.fullscreenLoading = false
                        this.cliente = response.data.user
                        this.type = response.data.type
                        this.fillLoginUsuario.cEmail = ''
                        this.fillLoginUsuario.cPassword = ''
                        this.$emit('loginCliente', this.cliente)
                        localStorage.setItem('user', JSON.stringify(this.cliente))
                        EventBus.$emit('authUser')
                        // console.log('--- ingreso como cliente ---')
                    }
                }).catch(error => {
                    this.fullscreenLoading = false
                    if(error.response.status == 401){
                        this.error = 1,
                        this.mensajeError.push(error.response.data.error)
                    }
                })
                // var url = '/api/user-login'
                // let params = this.fillLoginUsuario
                // axios.post(url, params).then(response => {
                //     console.log(response.data)
                // })
            }
        },
        mounted() {
            // console.log('--- componente modal inicio sesión ---')
        }
    }
</script>
